import { Theme } from "@mui/material/styles";
import { ComponentsPropsList } from "@mui/material";

// Components
import MuiTypography from "./components/typography";
import MuiDataGrid from "./components/data-grid";
import MuiButton from "./components/button";
import MuiIconButton from "./components/icon-button";
import MuiAutocomplete from "./components/autocomplete";
import MuiTabs from "./components/tabs";
import MuiInput from "./components/input";
import MuiMenu from "./components/menu";
import MuiToggleButton from "./components/toggle-button";
import MuiPagination from "./components/pagination";
import MuiAlert from "./components/alert";

export type OwnerStateThemeType = {
  theme: Theme;
  ownerState: ComponentsPropsList[keyof ComponentsPropsList] & Record<string, unknown>;
};

const overrides = (): Theme["components"] => {
  const dataGrid = MuiDataGrid();
  const button = MuiButton();
  const iconButton = MuiIconButton();
  const autocomplete = MuiAutocomplete();
  const tabs = MuiTabs();
  const input = MuiInput();
  const menu = MuiMenu();
  const toggleButton = MuiToggleButton();
  const pagination = MuiPagination();
  const alert = MuiAlert();

  const componentOverrides: Theme["components"] = Object.assign(MuiTypography, dataGrid, button, iconButton, autocomplete, tabs, input, menu, toggleButton, pagination, alert);

  // @ts-ignore - DataGrid is not part of theme components by default
  const combinedComponentOverrides: Theme["components"] = Object.assign(componentOverrides, dataGrid);

  return combinedComponentOverrides;
};

export default overrides;
